<template>
  <ion-page>
    <WhiteHeader :back-button="false" :title="name" />
    <ion-content fullscreen="true">
      <ion-list>
        <ion-item router-link="/documents">
          <ion-icon
            class="width-icon-img-30 ml-10"
            color="dark"
            slot="start"
            :icon="fileTrayOutline"
          ></ion-icon>
          <ion-label>Mes documents</ion-label>
        </ion-item>

        <ion-item router-link="/time-reports">
          <ion-icon
            class="width-icon-img-30 ml-10"
            color="dark"
            slot="start"
            :icon="timeOutline"
          ></ion-icon>
          <ion-label>Mes rapports hebdomadaires</ion-label>
        </ion-item>

        <ion-item router-link="/listeBonLocation">
          <ion-icon
            class="width-icon-img-30 ml-10"
            color="dark"
            slot="start"
            :icon="readerOutline"
          ></ion-icon>
          <ion-label>Mes BL / LV</ion-label>
        </ion-item>

        <ion-item router-link="/planning">
          <ion-img
            class="width-icon-img-30 ml-10"
            src="/assets/logo/LOCATIERS-ICONE_BLC.png"
            slot="start"
          ></ion-img>
          <ion-label>Mes missions</ion-label>
        </ion-item>

        <ion-item @click="openIntercom">
          <ion-icon
            class="width-icon-img-30 ml-10"
            color="dark"
            slot="start"
            :icon="chatbubbleEllipsesOutline"
          ></ion-icon>
          <ion-label>Contacter le support</ion-label>
        </ion-item>

        <ion-item router-link="/aide">
          <ion-icon
            class="width-icon-img-30 ml-10"
            color="dark"
            slot="start"
            :icon="helpCircleOutline"
          ></ion-icon>
          <ion-label>Aide &amp; contact</ion-label>
        </ion-item>

        <ion-item v-if="deferredPrompt || isIos()" @click="downloadApp">
          <ion-icon
            class="width-icon-img-30 ml-10"
            color="dark"
            slot="start"
            :icon="downloadOutline"
          ></ion-icon>
          <ion-label>Télécharger l'application</ion-label>
        </ion-item>

        <ion-item ref="installBanner" style="display: none; padding: 0 16px">
          <p>
            Pour installer l'application vous pouvez appuyer sur le bouton
            <ion-icon :icon="shareOutline" size="small"></ion-icon>
            Puis, sélectionner <strong>"Sur l'écran d'accueil"</strong>.
          </p>
        </ion-item>

        <ion-item class="bottom" @click="disconnecting" lines="none">
          <ion-icon
            class="width-icon-img-30 ml-10"
            color="danger"
            slot="start"
            :icon="logOutOutline"
          ></ion-icon>
          <ion-label color="danger">Se déconnecter</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonImg,
  toastController,
  isPlatform,
} from '@ionic/vue';
import {
  logOutOutline,
  helpCircleOutline,
  chatbubbleEllipsesOutline,
  fileTrayOutline,
  timeOutline,
  readerOutline,
  downloadOutline,
  shareOutline,
} from 'ionicons/icons';
import WhiteHeader from '@/components/driver/header/WhiteHeader';
import { clearData, getInfo } from '@/services/users';

export default {
  name: 'Settings',
  components: {
    WhiteHeader,
    IonPage,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonIcon,
    IonImg,
  },

  setup() {
    return {
      logOutOutline,
      helpCircleOutline,
      chatbubbleEllipsesOutline,
      fileTrayOutline,
      timeOutline,
      readerOutline,
      downloadOutline,
      shareOutline,
    };
  },

  data() {
    return {
      name: {},
      deferredPrompt: null,
    };
  },

  async mounted() {
    const { userData } = await getInfo();
    if (userData.agent.first_name && userData.agent.last_name) {
      this.name = userData.agent.first_name + ' ' + userData.agent.last_name;
    } else {
      this.name = userData.agent.name;
    }

    if ('serviceWorker' in navigator && 'PushManager' in window) {
      window.addEventListener('beforeinstallprompt', e => {
        this.deferredPrompt = e;
      });
    }
  },

  methods: {
    async openIntercom() {
      if (window.Intercom) {
        window.Intercom('show');
      } else {
        const toast = await toastController.create({
          message:
            'Intercom n\'est pas disponible. Utilisez "Aide et contact" si besoin.',
          position: 'bottom',
        });
        await toast.present();
      }
    },

    /**
     * Disconnection of the user with deletion of their locally saved data
     */
    disconnecting() {
      clearData();
      this.$router.push('/connexion');
    },

    isIos() {
      return isPlatform('ios');
    },

    downloadApp() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        return;
      }

      if (this.isIos()) {
        this.$refs.installBanner.$el.style.display = 'block';
      }
    },
  },
};
</script>

<style scoped lang="scss">
ion-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  .bottom {
    margin-top: auto;
  }
}
</style>
